import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './useAuth';

interface SuperAdminGuardProps {
  children: ReactNode;
}

/**
 * Guard específico para rutas SuperAdmin
 * Verifica que el usuario tenga rol 'superadmin'
 */
export function SuperAdminGuard({ children }: SuperAdminGuardProps) {
  const { session, profile, loading } = useAuth();

  // Si está cargando, mostrar spinner
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-teal-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Cargando...</p>
        </div>
      </div>
    );
  }

  // Si no hay sesión, redirigir a login
  if (!session) {
    return <Navigate to="/login" replace />;
  }

  // Si no hay perfil o no es superadmin, mostrar acceso denegado
  if (!profile || profile.role !== 'superadmin') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-lock-line text-3xl text-red-600"></i>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Acceso Denegado
          </h1>
          <p className="text-gray-600 mb-6">
            No tienes permisos para acceder al panel de SuperAdmin
          </p>
          <a
            href="/app"
            className="inline-flex items-center justify-center px-6 py-3 bg-gray-900 text-white rounded-lg font-medium hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Volver al Panel
          </a>
        </div>
      </div>
    );
  }

  // Si todo está OK, renderizar children
  return <>{children}</>;
}
